export const UNAUTHORIZED_STATUS_CODE = 401
export const SYS_CONFIG_STATUS_CODE = 405
export const SHOW_SYS_CONFIG = 'SHOW_SYS_CONFIG'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_TENANT_SELECT = 'LOGIN_TENANT_SELECT'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const SINGLE_SIGN_ON_FAILURE = 'SINGLE_SIGN_ON_FAILURE'
export const DEFAULT_LOGIN_ERROR_MESSAGE = 'Login Failure'

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'

export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS'
export const SEND_EMAIL_FAILURE = 'SEND_EMAIL_FAILURE'

export const SET_WFM_MENU_ITEMS = 'SET_TELEOPTI_MENU_ITEMS'

export const SET_FR_SESSION_INITIALIZED = 'SET_FR_SESSION_INITIALIZED'
export const SET_AUTH_LOCATION = 'SET_AUTH_LOCATION'
export const SET_FORGEROCK_ID_TOKEN = 'SET_FORGEROCK_ID_TOKEN'
export const SET_FR_LOGIN_URL = 'SET_FR_LOGIN_URL'
export const SET_FR_CLIENT_ID = 'SET_FR_CLIENT_ID'
export const SET_FR_OP_URL = 'SET_FR_OP_URL'
export const SET_FR_REALM = 'SET_FR_REALM'
export const SET_WAS_AUTH_FR = 'SET_WAS_AUTH_FR'
export const SET_AUTH_CONFIG = 'SET_AUTH_CONFIG'

export enum AuthenticationSource {
    OIDC = 'OIDC',
    IAM_AUTHENTICATION = 'IamAuthentication',
}

export enum AuthenticationType {
    DIRECT = 'DIRECT',
    SAML = 'SAML',
    OIDC = 'OIDC',
    CLASSIC_DIRECT = 'CLASSIC_DIRECT',
    CLASSIC_SAML = 'CLASSIC_SAML',
}
